<template lang="pug">
  b-container.content-wrap(fluid :class="{ 'is-mobile': isMobile }")
    b-row.mb-2
      b-col.page-wrap(cols="12")
        div.page-header(slot="header")
          b-container.d-flex.justify-content-between(fluid)
            span.page-title {{$t('management_page.manager_registration_request_approval')}}

    b-row.search-form
      b-col.mmb-10(cols="6" lg="2")
        b-form-datepicker(
          v-model="range.start"
          :bootstrap-styling="true"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="search"
        )
      b-col.mmb-10(cols="6" lg="2")
        b-form-datepicker(
          v-model="range.end"
          :bootstrap-styling="true"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="search"
        )
      b-col.mmb-10(cols="12" lg="5")
        b-input-group
          b-input-group-prepend
            b-form-select.mr-2(v-model="form.search_key" :options="selectOptions.list" size="sm")
          b-form-input.mr-2(v-if="selectInput.type === 'keyword'" v-model="form.search_value" size="sm" @keyup.enter="search")
          b-form-select.mr-2(v-if="selectInput.type === 'select'" v-model="form.search_value" :options="selectInput.list" size="sm")
          b-input-group-append
            b-btn(size="sm" @click="search") {{$t('search')}}

      b-col.right-btns
        b-btn.ml-2.view-mode-button(size="sm", :disabled="excelLoaded" @click="downloadExcel")
          img.mr-1(:src="`${AppState.Path.image}/icons/excel-icon.svg`" style="height: 0.9rem; vertical-align: middle;")
          span(v-if="!excelLoaded") {{$t('excel_button')}}
          span(v-else) Download...
        b-btn.ml-2(size="sm" variant="primary" @click="selectComplate(allChecked)") {{$t('management_page.select_approval')}}
    
    b-card.table-card
      b-table(
        ref="approvalTable"
        :fields="tableData.fields"
        :items="fetchList"
        :current-page="tableData.pagination.current"
        :per-page="tableData.pagination.limit"
        :empty-text="$t('no-content')"
        tbody-class="lmm-table-body"
        sort-by="create_time"
        :sort-desc="true"
        show-empty
        responsive
      )
        //- header
        template(v-slot:head(check)="row")
          b-form-checkbox(v-model="allSelected" @input="selectAllRows")

        //- body
        template(v-slot:cell(check)="row")
          b-form-checkbox(v-model="row.item.isSelected" :disabled="row.item.permission_flag !== 1" @change="handleCheck(row.item)")
        
        template(v-slot:cell(create_time)="row")
          span {{ row.item.create_time | moment('YY-MM-DD HH:mm') }}

        template(v-slot:cell(user_id)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.user_fk}}") {{row.item.user_id}}
        
        template(v-slot:cell(user_name)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.user_fk}}") {{row.item.user_name}}

        template(v-slot:cell(part_name)="row")
          b-btn(v-if="user.type !== 'SubManager'" variant="link", :to="{name: 'user-edit-department', params: {id: row.item.part_pk}}") {{row.item.part_name}}
          span(v-else) {{row.item.part_name}}

        template(v-slot:cell(approver_name)="row")
          b-btn(variant="link" @click="openDialogApprovalLineInfo(row.item)") {{row.item.approver_name}}

        template(v-slot:cell(name)="row")
          b-btn(variant="link", :to="{name: 'user-edit-department', params: {id: row.item.pk}}") {{row.item.name}}
        
        template(v-slot:cell(submanager)="row")
          b-btn(variant="link", :to="{name: 'edit-manager', params: {userPk: row.item.userPk}}") {{row.item.submanager}}
        
        template(v-slot:cell(count)="row")
          b-btn(variant="link" @click="visibleDialogDepartmentUser = true") {{row.item.count}}

        template(v-slot:cell(btn)="row")
          b-button.d-inline-flex(size="sm" variant="primary" :class="{ 'request' : row.item.permission_flag === 0 }" :disabled="row.item.permission_flag !== 1" @click="selectComplate([row.item])") 결재

    //- pagination
    .pagination-wrap
      div
        b-form-select(
          size="sm"
          v-model="tableData.pagination.limit"
          :options="tableData.pagination.perOptions"
        )
      b-pagination(
        size="sm"
        v-model="tableData.pagination.current"
        :total-rows="tableData.pagination.total"
        :per-page="tableData.pagination.limit"
        class="my-0 float-right"
      )

    confirm-dialogs(:show.sync="showComplate" :option="{ size: 'md', title: this.$t('management_page.manager_registration_request_approval') }")
      .select
        span(v-for="item of complateList" :key="item.pk") "{{$t('manager_str')}}({{ item.device_name }})"
      .box
        .msg {{$t('management_page.approve_manager_registration_requests')}}
      .bottom-btns
        b-btn(size="sm" variant="primary" @click="handleState(true)" pill) {{$t('approval')}}
        b-btn(size="sm" variant="danger" @click="handleState(false)" pill) {{$t('reject-submit')}}
        b-btn.btn-secondary(size="sm" @click="showComplate = false" pill) {{$t('cancel')}}
    
    dialog-approval-line-info(:show.sync="showDialogApprovalLineInfo" :form="approvalLineForm")
</template>

<script>
import { ManagementAPI, GetMgridAPI } from "@/api"
import ConfirmDialogs from "@/components/mixins/dialog/confirm.vue"
import DialogApprovalLineInfo from "../components/dialogApprovalLineInfo.vue"
import _ from "lodash"
import moment from "moment"
import { user } from "@/api/access"

export default {
  components: {
    ConfirmDialogs,
    DialogApprovalLineInfo,
  },
  computed: {
    selectInput() {
      return _.find(this.selectOptions.list, { value: this.form.search_key })
    },
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
  },
  watch: {
    "form.search_key"(val) {
      if (this.selectInput.type === "select") {
        this.form.search_value = this.selectInput.list[0].value
      } else {
        this.form.search_value = ""
      }
    },
  },
  mounted() {
    this.tableData.pagination.start_date = moment(this.range.start).format("YYYY-MM-DD")
    this.tableData.pagination.end_date = moment(this.range.end).format("YYYY-MM-DD")
  },
  data() {
    return {
      user: user(),
      range: {
        start: moment()
          .add(-14, "days")
          .toDate(),
        end: moment().toDate(),
      },
      form: {
        search_key: "user_name",
        search_value: "",
      },
      selectOptions: {
        list: [
          { text: this.$t('applicant'), value: "user_name", type: "keyword" },
          { text: this.$t('department'), value: "part_name", type: "keyword" },
          { text: this.$t('applicant'), value: "approver_name", type: "keyword" },
          { text: this.$t('manager_name'), value: "device_name", type: "keyword" },
          {
            text: "OS",
            value: "manager_os",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: "UNKNOWN", value: "0" },
              { text: "Windows", value: "1" },
              { text: "Linux", value: "2" },
              { text: "OS_X", value: "3" },
              { text: "Android", value: "4" },
              { text: "iOS", value: "5" },
            ],
          },
        ],
      },
      excelLoaded: false,
      excelLink: null,

      allSelected: false,
      allChecked: [],
      tableData: {
        fields: [
          {
            key: "check",
            label: "",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: false,
            thStyle: { width: "1%" },
          },
          { key: "create_time", label: this.$t('application_datetime'), sortable: true, thStyle: { minWidth: "130px" }, tdClass: "text-nowrap" },
          { key: "user_id", label: this.$t('ID'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "user_name", label: this.$t('applicant'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "part_name", label: this.$t('department'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "approver_name", label: this.$t('approver'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "device_name", label: this.$t('manager_str'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "manager_os", label: "OS", sortable: true, thStyle: { minWidth: "100px" }, tdClass: "text-nowrap" },
          { key: "btn", label: this.$t('approval_process'), thClass: "text-center", thStyle: { minWidth: "70px" }, tdClass: "text-nowrap text-center" },
        ],
        list: [],
        pagination: {
          by: "create_time",
          limit: 24,
          offset: 0,
          order: "desc",

          start_date: "2023-08-30",
          end_date: "2023-09-12",

          reqeust_type: 1,

          search_key: "",
          search_value: "",
          search_mode: "pagination",

          total: 1,
          current: 1,
          perOptions: [
            { value: 12, text: "12" },
            { value: 24, text: "24" },
            { value: 36, text: "36" },
          ],
        },
      },

      showComplate: false,
      complateList: [],

      showDialogApprovalLineInfo: false,
      approvalLineForm: {
        type: 2,
        type_pk: null,
      },
    }
  },
  methods: {
    fetchList(ctx) {
      if (ctx.sortBy === "") return

      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit

      let params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,

        start_date: this.tableData.pagination.start_date,
        end_date: this.tableData.pagination.end_date,

        request_type: this.tableData.pagination.reqeust_type,

        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",
      }

      return ManagementAPI.management.get("manager", { params }).then(res => {
        const { objects, meta, status } = res.data
        if (status !== 200) {
          this.$awn.warning(this.$t('toasts_message.data_fetch_failed'))
          return []
        }

        this.tableData.list = objects
        this.tableData.pagination.total = meta.total_count
        return this.tableData.list
      })
    },
    openDialogApprovalLineInfo(item) {
      this.approvalLineForm.type_pk = item.type_pk
      this.showDialogApprovalLineInfo = true
    },
    search() {
      this.tableData.pagination.start_date = moment(this.range.start).format("YYYY-MM-DD")
      this.tableData.pagination.end_date = moment(this.range.end).format("YYYY-MM-DD")
      this.tableData.pagination.current = 1

      this.tableData.pagination.search_key = this.form.search_key
      this.tableData.pagination.search_value = this.form.search_value
      this.$refs.approvalTable.refresh()
    },

    async downloadExcel() {
      this.excelLoaded = true
      const params = await this.fetchExcel()
        .then(params => {
          //전송용 임시 폼 엘리먼트 생성
          var form = document.createElement("form")
          form.method = "post"
          form.action = "/download/excel.html" // /download/excel.html을 통해 DownloadExcelFileAPI호출

          // 엑셀 생성에 필요한 필터된 데이터를 폼에 추가
          let jsonData = {...params, language: this.$i18n.locale}
          var input = document.createElement("input")
          input.type = "hidden"
          input.name = "jsondata"
          input.value = JSON.stringify(jsonData)
          form.appendChild(input)

          // body에 폼 추가 및 제출 그 후 제거
          document.body.appendChild(form)
          form.target = "_blank"
          form.submit()
          document.body.removeChild(form)

          this.excelLoaded = false
        })
        .catch(err => {
          this.excelLoaded = false
          alert(this.$t('toasts_message.no_data_to_download_excel'))
          return
        })
    },

    async fetchExcel() {
      let params = {
        by: this.tableData.pagination.by,
        limit: 0,
        offset: 0,
        order: this.tableData.pagination.order,

        start_date: this.tableData.pagination.start_date,
        end_date: this.tableData.pagination.end_date,

        request_type: this.tableData.pagination.reqeust_type,

        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",
      }

      if (this.tableData.pagination.total < 1) {
        throw new Error(this.$t('no_data_available'))
      }
      const list = await ManagementAPI.management.get("manager", { params })

      const excelParams = list.data

      //console.log(excelParams.objects)
      const { data } = await GetMgridAPI.get("")
      const excelParams_for_download = {
        api: excelParams.api,
        excel_doc_title: "",
        pagename: "",
        mgrid: data.objects.mgrid,
        objects: this.downloaded_excel_data_form(excelParams.objects),
      }
      excelParams_for_download.pagename = "manager_approval"
      //console.log(excelParams_for_download)
      excelParams_for_download.excel_doc_title = this.$t('management_page.manager_registration_request_approval')

      return excelParams_for_download
    },
    downloaded_excel_data_form(input) {
      let originalLocale = this.$i18n.locale
      this.$i18n.locale = "ko"
      
      //input = excelParams.objects
      let output = []
      for (let index = 0; index < input.length; index++) {
        let obj = {
          [this.$t('application_datetime')]: input[index]["create_time"],
          [this.$t('ID')]: input[index]["user_id"],
          [this.$t('applicant')]: input[index]["user_name"],
          [this.$t('department')]: input[index]["part_name"],
          [this.$t('approver')]: input[index]["approver_name"],
          [this.$t('manager_str')]: input[index]["device_name"],
          OS: input[index]["manager_os"],
        }
        let obj2 = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, this.nullcheck(value)]))
        output.push(obj2)
      }
      this.$i18n.locale = originalLocale
      return output
    },
    nullcheck(input) {
      return input == null ? "-" : input
    },
    Date_time_split(input) {
      let return_array = []
      if (input != "-") {
        let input_array = input.split("T")
        return_array[0] = input_array[0]
        return_array[1] = input_array[1]
          .split(":")
          .slice(0, 2)
          .join(":")
      } else {
        return_array[0] = "-"
        return_array[1] = "-"
      }
      return return_array
    },
    handleCheck(item) {
      if (this.allChecked.includes(item)) {
        const index = this.allChecked.findIndex(u => u.pk === item.pk)
        this.allChecked.splice(index, 1)
      }
      if (item.isSelected) {
        this.allChecked.push(item)
      }
    },
    selectAllRows() {
      _.each(this.tableData.list, v => {
        if (this.allSelected) {
          if (v.permission_flag === 1) {
            v.isSelected = this.allSelected
            this.handleCheck(v)
          }
        } else {
          v.isSelected = this.allSelected
        }
      })
    },

    selectComplate(items) {
      if (items.length === 0) {
        this.$bvToast.toast(this.$t('toasts_message.no_selected_applicants'), {
          title: "Warning",
          variant: "warning",
          solid: true,
        })
        return
      }
      this.complateList = _.cloneDeep(items)
      this.showComplate = true
    },

    async handleState(state) {
      let result = true
      for (const item of this.complateList) {
        const params = {
          request_type: "manager",
          manager_device_pk: item.manager_device_pk,
          registration_status: state ? 2 : 1,
        }
        // @@@ 이 부분 변경 필요 API의 경로 이슈
        await ManagementAPI.manager.put("approval", params).catch(err => {
          result = false
        })
      }
      this.showComplate = false
      if (result) {
        alert(this.$t('toasts_message.approval_completed'))
        this.$refs.approvalTable.refresh()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.request {
  &:disabled {
    background-color: #ccc;
    border-color: #ccc;
  }
}
</style>
